import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles.css'
import i18n from './i18n'
import 'vue3-toastify/dist/index.css'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(i18n)
app.mount('#app')

store.dispatch('initializeTheme')
store.watch(
  state => state.isDarkMode,
  newValue => {
    document.body.setAttribute('data-theme', newValue ? 'dark' : 'light')
  },
  { immediate: true }
)
